import styled from 'styled-components'

interface IAppHeaderUserStyledProps {}

export const AppHeaderUserStyled = styled.div<IAppHeaderUserStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
